import { Navigate } from "react-router-dom";
import { LegacyNotFoundPage } from "../bridges/legacyPages";
import { useSwitchParams } from "./useSwitchParams";

/** Legacy side of the new contact page and history: today's edit page for a numeric id, today's 404 otherwise. */
export const LegacyContactRedirect = () => {
  const { id = "" } = useSwitchParams();
  if (!/^\d+$/.test(id)) return <LegacyNotFoundPage />;
  return <Navigate to={`/households/update/household-info/${id}`} replace />;
};
